import { IAnalyticsData } from '../components/Analytics/Analytics'

import axiosAuth from './axiosAuth'

export const getAnalytics = (controller: AbortController, params: string) =>
    axiosAuth.get<Record<string, IAnalyticsData>>(
        `/conversation_stats${params ? '?' + params : ''}`,
        {
            signal: controller.signal,
        }
    )

interface IGetExportReportParams {
    date_from?: string
    date_to?: string
}

export const getExportReport = (
    controller: AbortController,
    params: IGetExportReportParams
) => {
    return axiosAuth.get<Blob>(`/conversation_stats/export`, {
        params,
        responseType: 'blob',
        signal: controller.signal,
    })
}
